export const MAX_MANUFACTURING_ORDER_LINES = 200;
export const MAX_MANUFACTURING_ORDER_LINES_MESSAGE = `A manufacturing order can have at most ${MAX_MANUFACTURING_ORDER_LINES} part lines.`;
export const MANUFACTURING_ORDER_CONSTRAINTS = {
    brand: { label: 'Brand' },
    locationGroup: { label: 'Warehouse' },
    part: { label: 'Part' },
    // Upper bound stays well under the Decimal(28,9) column's overflow point.
    quantity: { label: 'Quantity', max: 1_000_000_000 },
    note: { label: 'Note', maxLength: 2000 },
    /** Enough for a shift's crew; a work order assigned to more than this is a planning mistake. */
    assignees: { label: 'Assignees', max: 25 },
    name: { label: 'Line name', maxLength: 256 },
    /** A job says only when it is due; it is not run between two dates, so it has no start. */
    dateScheduled: { label: 'Scheduled' },
    // A work order is the thing actually run between two dates, so it is the only one with a
    // window. These name its ends, and the field a server-side error is reported against.
    dateScheduledToStart: { label: 'Scheduled start' },
    scheduledEnd: { label: 'Scheduled end' },
};
//# sourceMappingURL=constraints.js.map